import { useNavigate } from "react-router-dom";
import { ROUTES } from "../app/routes";
import { useI18n } from "../i18n/I18nProvider";
import { Button, Card, CodeBlock, typographyClass } from "../ui-kit";
import { CatalogAlerts, CatalogPage } from "./CatalogPage";

/** Шаги квикстарта. Нумерация здесь осмысленна: это последовательность вызовов. */
const STEPS = ["1", "2", "3"] as const;

const quickstart = (t: (key: string) => string) =>
  [
    t("quickstart.step1"),
    'curl "$PORTAL_URL/api/models"',
    "",
    t("quickstart.step2"),
    'curl "$PORTAL_URL/api/models/kling"',
    "",
    t("quickstart.step3"),
    'curl -X POST "$PORTAL_URL/api/models/kling" \\',
    "  -H 'Content-Type: application/json' \\",
    '  -H "X-Api-Key: $PHYGITAL_API_KEY" \\',
    `  -d '{"inputs":{"text_prompt":"create cat"},"params":{"duration":"sec_5"}}'`,
    "",
    t("quickstart.step4"),
    'curl "$PORTAL_URL/api/tasks/184293" -H "X-Api-Key: $PHYGITAL_API_KEY"',
  ].join("\n");

/**
 * Первый экран: «как это работает» рядом с квикстартом, ниже — каталог моделей.
 *
 * По макету дизайнера каталог живёт на этом же экране, а не отдельной страницей:
 * человек читает три шага и сразу выбирает модель, без лишнего перехода.
 */
export function OverviewPage() {
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <>
      <CatalogAlerts />

      <div className="page-hero">
        <Card>
          <h1 className={typographyClass("header-24-semibold")}>{t("overview.title")}</h1>
          <p className={typographyClass("text-14-medium")} style={{ color: "var(--color-text-secondary-v2)" }}>
            {t("overview.subtitle")}
          </p>

          <ol className="steps">
            {STEPS.map((step) => (
              <li key={step}>
                <h2 className={typographyClass("text-14-semibold")}>{t(`overview.step${step}.title`)}</h2>
                <p className={typographyClass("caption-13-medium")} style={{ color: "var(--color-text-secondary-v2)" }}>
                  {t(`overview.step${step}.text`)}
                </p>
              </li>
            ))}
          </ol>

          <Button fullWidth onClick={() => navigate(ROUTES.catalog)}>
            {t("nav.catalog")}
          </Button>
        </Card>

        <CodeBlock code={quickstart(t)} language="cURL" numbered copyLabel={t("action.copy")} />
      </div>

      <CatalogPage alerts={false} />
    </>
  );
}
